import styled from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { headerHeight } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling.tsx';

export const ContactPhone = styled.div``;
export const ContactMail = styled.a``;
export const ContactDetailsWrapper = styled(Flex)<FlexProps>``;

export const HeaderLogo = styled(Icon)`
	&.svg {
		width: 6rem;
		height: unset;
	}
`;
export const LeftPart = styled(Flex)<FlexProps>``;

export const RightPart = styled(Flex)<FlexProps>`
	${ContactDetailsWrapper} {
		${ContactPhone}, ${ContactMail} {
			display: flex;
			align-items: center;
			padding: 0.5rem;
		}
		${Icon} {
			margin-right: 0.5rem;
		}
	}
`;

export const HeaderContainer = styled.div`
	display: flex;
	box-sizing: border-box;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 2rem;
	height: ${headerHeight};
	background-color: ${({ theme }) => theme.v3.colors.white[5]};
	color: ${({ theme }) => theme.v3.colors.dark[8]};
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
`;
